export default {
  D1: {
    sv: [
      { uid: "ddadfsfs", text: "Tillbaka", type: "prev" },
      { uid: "asdfkasljdg", text: "Nästa", type: "next" }
    ],
    en: [
      { uid: "ddadfasdfsfs", text: "Back", type: "prev" },
      { uid: "asdfkadsag", text: "Next", type: "next" }
    ],
    ar: [
      { uid: "ddasdgadfasdfsfs", text: "عودة", type: "prev" },
      { uid: "asdfkahtdsag", text: "التالي", type: "next" }
    ]
  },
  D3: {
    sv: [
      { uid: "asdfvcxb", text: "Tillbaka", type: "prev" },
      { uid: "db,csf", text: "Nästa Färdighet", type: "nextSkill" },
      { uid: "flncxzv", text: "Nästa Nivå", type: "nextLevel" },
      { uid: "adsökn", text: "Nästa", type: "next" },
      { uid: "asgasgagsgsa", text: "Avsluta", type: "finish" },
    ],
    en: [
      { uid: "asdsdffvcxb", text: "Back", type: "prev" },
      { uid: "db,csasf", text: "Next Skill", type: "nextSkill" },
      { uid: "asdfflncxzv", text: "Next", type: "next" },
      { uid: "adsöknbafd", text: "Next Level", type: "nextLevel" },
      { uid: "asfasgags", text: "Finish", type: "finish" }
    ],
    ar: [
      { uid: "asadsdsdffvcxb", text: "عودة", type: "prev" },
      { uid: "db,cfdsasasf", text: "Next Skill", type: "nextSkill" },
      { uid: "asdfflncsvfdxzv", text: "التالي", type: "next" },
      { uid: "adsasdvökn", text: "Next Level", type: "nextLevel" },
      { uid: "fwfwas", text: "انهاء", type: "finish" },
    ]
  }
};
